module.exports = __webpack_public_path__ + "img/filter-sample.335832e6.jpg";